import { Component, OnInit } from '@angular/core';
import { FavoriteService } from 'src/app/services/favorite.service';
import { ErrorHandlerService } from 'src/app/services/error-handler.service';
import { ProductModel } from 'src/app/models/wardrobe.model';

@Component({
  selector: 'shc-favorites',
  templateUrl: './favorites.page.html',
  styleUrls: ['./favorites.page.scss'],
})
export class FavoritesPage implements OnInit {
  products: Array<ProductModel> = [];
  loading = true;

  constructor(
    private favoriteService: FavoriteService,
    private errorService: ErrorHandlerService,
  ) {}

  ngOnInit() {
    this.loadFavorites();
  }

  ionViewWillEnter() {
    this.loadFavorites();
  }

  loadFavorites() {
    this.loading = true;
    this.favoriteService.favoritesList().subscribe(
      (res) => {
        this.products = res?.data || [];
        this.products.forEach((product) => {
          product.favorited = true;
        });
        this.loading = false;
      },
      (error) => {
        this.loading = false;
        this.errorService.handle(error);
      },
    );
  }

  toggleFavorite(product: ProductModel, event: Event) {
    event.stopPropagation();
    this.favoriteService.toggleFavorite(product.id).subscribe(
      () => {
        this.products = this.products.filter((p) => p.id !== product.id);
      },
      (error) => {
        this.errorService.handle(error);
      },
    );
  }
}
